enum SharingType {
    OneTime,
    Continuous,
    Scheduled,
}

export default SharingType;
